// https://www.driftingruby.com/episodes/sweetalerts-in-rails-6
import swal from 'sweetalert2'
import Rails from '@rails/ujs'
import Swiper, { Navigation, Controller, Pagination, FadeEffect, Manipulation } from 'swiper';

Swiper.use([Navigation, Controller, Pagination, Manipulation])

Rails.confirm = function (message, element) {
  if(element.getAttribute('data-typeview') === 'modal') {
    let setting = {
      title: element.getAttribute('data-title'),
      message: message,
      appendTo: element.getAttribute('data-appendto'),
      buttons: element
    }
    confirmationDialog(setting).then(() => {
      element.removeAttribute('data-confirm')
      element.click()
    }).catch((error) => {});
  } else {
    let title = element.getAttribute('data-title');
    let htmldata =  (title ? '<p class="swal-title">'+title+'</p><p class="swal-message">'+message+'</p>' : '<p class="swal-title">'+message+'</p>');
    const swalWithBootstrap = swal.mixin({
      customClass:{
        cancelButton: "btn btn-white px-4 me-3",
        confirmButton: "btn btn-secondary px-4"
      },
      focusConfirm: false,
      buttonsStyling: false,
      reverseButtons: true,
    });
  
    swalWithBootstrap.fire({
      html: htmldata,
      showCancelButton: true,
      confirmButtonText: I18n.app.yes,
      cancelButtonText: I18n.app.no
    }).then((result) => {
      if (result.value) {
        element.removeAttribute('data-confirm')
        element.click()
      }
    });
  }
}

$(document).on('show.bs.modal', '.modal', function () {
  window.isCaption;
  activateValidation();
  $(function () {
    $(".modal #create-post-selectable-tags .meta-checkbox input[type='checkbox']").change(function () {
      if($('.meta-checkbox input[type="checkbox"]:checked').length > 0){
        $(document).on('keyup', function(event){
          if( parseInt(event.keyCode,10) === 13 ){
             $('.validate-filter-enter-create-post').trigger( "click" );
          } 
        });
      }
    })
  });
});

$(document).on('hidden.bs.modal', '.create-post-modal', function () {
  $('.modal.create-post-modal').remove();
});

document.addEventListener("turbolinks:load", function () {
  activateValidation();
  function activaTab(tab){
    $('.nav-tabs a[href="#' + tab + '"]').tab('show');
  };
  hideVideoSwitch();
  showCoverSwitch();
  //var tabActive= 'cover';
  $(document).on('shown.bs.tab', '#myTab a[data-bs-toggle="tab"]', function (e) {
    //tabActive=(e.target.href).split('#').pop();
    //if(tabActive === 'cover' ){
     //window.location.href=window.location.pathname;
    //}
    if(e.target.id == "cover-tab"){
     // console.log('Hide Video Tab Switch Show Cover Tab switch');
      hideVideoSwitch();
      showCoverSwitch();
      activaTab('cover');
    }
    else if(e.target.id == "video-tab"){
     // console.log('Hide cover Tab Switch Show video Tab switch');
      showVideoSwitch();
      hideCoverSwitch();
      activaTab('video');
    }
  });

  // Dropdown menu autoscroll to active
  $(".dropdown, .dropdown-center").on("shown.bs.dropdown", function() {
    $(this).find(".dropdown-menu a.active").focus()
 });

  if (window.location.href.indexOf("type=video") > -1) {  
      $('#cover.tab-pane').removeClass('show');
      $('#cover.tab-pane').removeClass('active');
      $('#video.tab-pane').addClass('show');
      $('#video.tab-pane').addClass('active');
      showVideoSwitch();
      hideCoverSwitch();
      // if($('#video_pipeline_activation').is(':checked')) {
      //   console.log('--video_pipeline_activation checked');
      //   $('#cover.tab-pane').removeClass('show');
      //   $('#cover.tab-pane').removeClass('active');
      //   $('#video.tab-pane').addClass('show');
      //   $('#video.tab-pane').addClass('active');
      // }
      // else{
      //   console.log('--video_pipeline_activation not checked');
      //   $('#cover.tab-pane').removeClass('show');
      //   $('#cover.tab-pane').removeClass('active');
      //   $('#video.tab-pane').addClass('show');
      //   $('#video.tab-pane').addClass('active');
      // }
  }
  else if (window.location.href.indexOf("type=cover") > -1){
      $('#cover.tab-pane').addClass('show');
      $('#cover.tab-pane').addClass('active');
      $('#video.tab-pane').removeClass('show');
      $('#video.tab-pane').removeClass('active');
      hideVideoSwitch();
      showCoverSwitch();
  }

  function hideVideoSwitch(){
    $('.video-tab-switch').addClass('d-none');
    $('.video-tab-switch').removeClass('d-flex');
  }
  function showVideoSwitch(){
    $('.video-tab-switch').removeClass('d-none');
    $('.video-tab-switch').addClass('d-flex');
  }
  function hideCoverSwitch(){
    $('.cover-tab-switch').addClass('d-none');
    $('.cover-tab-switch').removeClass('d-flex');
  }
  function showCoverSwitch(){
    $('.cover-tab-switch').removeClass('d-none');
    $('.cover-tab-switch').addClass('d-flex');
  }

 
  $('.history a[data-bs-toggle="tab"]').on('show.bs.tab', function(e) {
    localStorage.setItem('activeTab', $(e.target).attr('href'));
    showPublished($(e.target).attr('href'));
  });
  var activeTab = localStorage.getItem('activeTab');
  function showPublished(activeTab){
    if (activeTab === "#tab-calendar"){
      $(".only-calendar-view").removeClass("d-none");
    } else {
      $(".only-calendar-view").addClass("d-none");
    }
  };
  if(activeTab){
    $('.history a[href="' + activeTab + '"]').tab('show');
  }

  if($(".page-content-wrapper").find('.alert.alert-info').length > 0){
    
    $(".content-box").css("margin-top", "65px");
    $(".content-box").addClass('test');
  }
  if($('#text_selected_area_id div').first().html()=="&nbsp;"){
    $('#text_selected_area_id div').first().remove();
  }
  
  $('html').keyup(function(e){
    if(e.keyCode == 8){
      $('#text_selected_area_id').find('span').each(function() { 
        console.log(this.hasAttribute('style'));
        if(this.hasAttribute('style')){
          $(this).contents().unwrap();
        }
    });
    }
  });
});

function activateValidation() {
  let form
  $('.filters-form').each(function(index, frm) {
    form = frm;
    if(form) {
      ['submit'].forEach(function(event) {
        form.addEventListener(event, (e) => {
          form = $(e.submitter).closest('.filters-form')
          for(var input of $(form).find('input:not(.hidden-data)').serializeArray()) {
            if(input.value !== '') {
              showClearFilter();
              break;
            } else {
              hideClearFilter();
            }
          }
          for(var input of $(form).find('select').serializeArray()) {
            if(input.value !== '') {
              showClearFilter();
              break;
            } else {
              hideClearFilter();
            }
          }
        });
      });
    
      $(form).find('.filters-header .clear-action').click(function() {
        $(form).trigger("reset");
        hideClearFilter();
      });
    }
  });
  
  function showClearFilter() {
    $(form).find('.filters-header .clear-action').css('display', 'flex');
  }
  
  function hideClearFilter() {
    $(form).find('.filters-header .clear-action').hide();
  }
}

$(document).on('hide.bs.modal', '.modal', function () {
  let video= $(this).find('.modal-body video');
  if (video[0]){
    video[0].pause();
  }
  $('.edit_property_content_modal .update-name').addClass('d-none');
  $('.edit_property_content_modal .edit-name').removeClass('d-none');
  $('.edit_property_content_modal .name-action input').attr('readonly', true);
  window.isCalendarDateChange=false;
});

$(document).on('click', '#badge-feature-holder .badge', function (e) {
  var objClick= e.target
  var objClickData= $(objClick).attr('data-id');
  var createdDoc= "<span contenteditable='false' id= '"+objClickData+"'>" + $(this).text() +"</span>&nbsp;";
  var html = $.parseHTML( createdDoc )
  //$(".text_selected_area").append(html);
  $(".text_selected_area").focus();
  pasteHtmlAtCaret(createdDoc);
  if ($('.gmb-clickable').prop('checked') == true){
    let action_url = $(objClick).attr('href') != "#" ? $(objClick).attr('href') : location.href
    $('#caption_google_action_url').val(action_url);
  }
});

function pasteHtmlAtCaret(html) {
  var sel, range;
  if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();

          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(), node, lastNode;
          while ( (node = el.firstChild) ) {
              lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);
          
          // Preserve the selection
          if (lastNode) {
              range = range.cloneRange();
              range.setStartAfter(lastNode);
              range.collapse(true);
              sel.removeAllRanges();
              sel.addRange(range);
          }
      }
  } else if (document.selection && document.selection.type != "Control") {
      // IE < 9
      document.selection.createRange().pasteHTML(html);
  }
}

// Form select as link selector
$(document).on('change', '.select-link', function (e) {
  location.href = $(this).find(":selected").val()
});

$(document).on('click', '.tag_submit_btn', function (e) {
  var socialMediaName = e.target.id.split('_')[0];

  var selectedTabName = socialMediaName+'_update_captions_form';
    e.preventDefault();
    spin(true);
  let textareaHTML = $("#"+socialMediaName+"_text_selected_area").html().replace(/(<.*?>)|\s+/g, (m, $1) => $1 ? $1 : ' ');

  $('#'+socialMediaName+'_textArea_div_value').html(textareaHTML);
  $('#'+socialMediaName+'_textArea_div_value span').each(function(index) {
    $(this).text('{'+this.id+'}');
  });
  $('#'+socialMediaName+'_textArea_div_value div').each(function(index,value) {
      $(this).text('\n'+$(this).text());
  });
  let dataParser = $('#'+socialMediaName+'_textArea_div_value').text().trim();
  
  let caption_params = {"caption": dataParser}
  if (socialMediaName == 'gmb' && $('.gmb-clickable').prop('checked') == true){
    caption_params = add_caption_option(caption_params)
  }else if(socialMediaName == 'gmb' && $('.gmb-clickable').prop('checked') == false){
    caption_params.action_type = ''
    caption_params.action_url = ''
  }

  $.ajax({
    url: $("#"+selectedTabName).attr('action'),
    type: 'PUT',
    data: {
      caption_generation_plugin: caption_params
    },
    dataType: "script"
  });
  spin(false);
});


function add_caption_option(caption_params) {
  var _option = $('.gmb-clickable-options select').val()
  var _option_url_val = setActionUrl()
  if ($('.gmb-clickable').prop('checked')){
    caption_params.action_type = _option
    caption_params.action_url = (_option == 'call' ? '' : _option_url_val)
  }else{
    caption_params.action_type = _option
    caption_params.action_url = ''
  }
  return caption_params
}
$(document).on('click', '#canvaBottomSegment', function (e) {
  $('#canvaBtn').trigger('click');
})

// check content is empty or not to enable the save button
$(document).ready(() => {
  const networks = ['facebook', 'instagram', 'linkedin', 'twitter', 'youtube', 'gmb']
  networks.forEach((network) => {
    const observerConfig = { childList: true, subtree: true }
    const observerTarget = document.getElementById(`${network}_text_selected_area`)
    if (!observerTarget) { return }

    const observer = new MutationObserver(() => {
      const caption = $('#'+network+'_text_selected_area').text().trim()
      const button = $(`button#${network}_update_captions_form`)
      const disabled = caption.length === 0
      button.attr('disabled', disabled)
    })
    observer.observe(observerTarget, observerConfig)
  })
})

$(document).on('click', '.caption_submit_btn', (e) => {
  e.preventDefault()

  const socialMediaName = e.target.id.split('_')[0]
  const selectedTabName = socialMediaName + '_update_captions_form'
  const form = $('#' + selectedTabName)
  const textarea = $($('.text_selected_area')[0]).html().replace(/(<.*?>)|\s+/g, (m, $1) => $1 ? $1 : ' ').trim()
  $('#'+socialMediaName+'_textArea_div_value').html(textarea)
  $('#'+socialMediaName+'_textArea_div_value span').each(function(index) {
    $(this).text('{'+this.id+'}');
  });
  $('#'+socialMediaName+'_textArea_div_value div').each(function(index,value) {
      $(this).text('\n'+$(this).text());
  });

  const caption = $('#'+socialMediaName+'_textArea_div_value').text().trim()
  const themeId = $('#caption-legend-theme-id').find('option:selected').val()
  const ajaxData = { caption_generation_plugin: { caption, theme_id: themeId } }

  if (socialMediaName === 'gmb' && $('.gmb-clickable').prop('checked')) {
    const actionType = $('#gmb_legend_action_type').val()
    const html = $('#gmb_caption_action_url').html().replace(/(<.*?>)|\s+/g, (m, $1) => $1 ? $1 : ' ').trim()
    $('#gmb_caption_action_url_format').html(html)
    $('#gmb_caption_action_url_format a').each(function(index) { $(this).text('{'+$(this).attr('data-id')+'}') })
    $('#gmb_caption_action_url_format div').each(function(index, value) { $(this).text('\n'+$(this).text()) })
    const actionUrl = $('#gmb_caption_action_url_format').text().trim()

    ajaxData.caption_generation_plugin['action_type'] = actionType
    ajaxData.caption_generation_plugin['action_url'] = actionType === 'learn_more' ? actionUrl : null
  } else if (socialMediaName === 'gmb') {
    ajaxData.caption_generation_plugin['action_type'] = null
    ajaxData.caption_generation_plugin['action_url'] = null
  }

  const redirect = (data) => {
    const url = `/users/captions/${data.caption_generation_plugin_id}/captions_legends/${data.id}`
    window.location.href = url
  }

  $.ajax({
    url: form.attr('action'),
    type: form.attr('data-method'),
    dataType: 'json',
    data: ajaxData,
    success: (data) => { window.spin(false); redirect(data) },
    error: (error) => { window.spin(false); console.log(error) }
  })
})

// switch to desired theme
$(document).on('change', '#caption-legend-theme-id', (e) => {
  e.preventDefault()

  const select = $('#caption-legend-theme-id')
  const option = select.find('option:selected')
  const socialNetwork = option.attr('data-social-network')
  const captionId = option.attr('data-caption-id')
  const themeId = option.val()

  if (captionId) {
    // redirect to view the existing caption
    window.location.href = `/users/captions/${captionId}`
  } else {
    // create a new caption for the selected theme
    ajaxCreateCaption(socialNetwork, themeId)
  }
})

// create a new caption for the selected theme, and redirect to the new caption
const ajaxCreateCaption = (socialNetwork, themeId) => {
  window.spin(true)

  const ajaxData = {
    type: socialNetwork,
    caption_generation_plugin: {
      theme_id: themeId
    }
  }

  $.ajax({
    url: '/users/captions',
    type: 'POST',
    dataType: 'json',
    data: ajaxData,
    success: (data) => {
      window.spin(false)
      window.location.href = `/users/captions/${data.id}`
    },
    error: (error) => {
      window.spin(false)
      console.log(error)
    }
  })
}

$(document).on('click', '.pipeline_activate_checkbox', (e) => {
  e.preventDefault()

  const socialMediaName = e.target.id.split('_')[0]
  const selectedTabName = socialMediaName + '_activate_captions_form'
  const form = $('#' + selectedTabName)
  const active = $('.pipeline_activate_checkbox')[0].checked

  const redirect = (data) => { window.location.href = `/users/captions/${data.id}` }

  $.ajax({
    url: form.attr('action'),
    type: form.attr('data-method'),
    dataType: 'json',
    data: { caption_generation_plugin: { active } },
    success: (data) => { window.spin(false); redirect(data) },
    error: (error) => { window.spin(false); console.log(error) }
  })
})

function setActionUrl () {
  let _caption_plugin_value = ''
  let _option_val = ''
  let _action_url = $('#gmb_caption_action_url').html().replace(/\r?\n|\r|\t|\b/g, '').trim()

  if (_action_url != '') {
    _action_url = _action_url.split('<a')[0].replace(/\r?\n|\r|\t|\b/g, '').trim()

    if (_action_url != '' && _action_url.slice(-1) != '/' && _action_url.slice(-1) != '}') {
      _action_url = _action_url + '/'
    }

    $('#gmb_caption_action_url a').each(function(index){
      if(index == $('#gmb_caption_action_url a').length - 1){
        _caption_plugin_value += "{" + $(this).attr('data-id') + "}"
      }else{
        _caption_plugin_value += "{" + $(this).attr('data-id') + "}/"
      }
    })

    _option_val = (_action_url + _caption_plugin_value).replace(/\r?\n|\r|\t|\b/g, "").trim()
  }
  return _option_val
}


//implemented a hack for CCI-607 User cannot click on the Settings Avatar on the My Property-related contents page
var url = location.pathname;
var result= url.split('/');
var Param1 = result[result.length-2];
var Param2 = result[result.length-1];
var Param3 = '/'+Param1+'/'+Param2;
//if(location.pathname=="/foo_page.html") alert('hey!');

if(Param3 == '/contents/properties'){
  setTimeout(function () {
    ///$('.dropdown').unbind();
    $('.dropdown-toggle').unbind(); 
    $('.dropdown-toggle').trigger('click');
    $('.dropdown-toggle').trigger('click');  
  }, 2000);
}
// hack end

$(function () {
  $(".side-filters .meta-checkbox input[type='checkbox']").change(function () {
    if($('.meta-checkbox input[type="checkbox"]:checked').length > 0){
      $(document).on('keyup', function(event){
        if( parseInt(event.keyCode,10) === 13 ){
           $('.validate-filter-enter').trigger( "click" );
        } 
      });
    }
  })
});


$(document).on('click', '#tab-list .publication-image-container a, .posts-list article figure a', function (e) {
  window.getMetaDataOfTabcalender = (url) => {
    $.ajax({
      type: "GET",
      url: "/dashboard/get_meta_data",
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
      },
      data: {
        url: url,
      },
      success: function (result){
        console.log(result);
      },
      error: function (error){
        //displayOgImage();
      }
    });
  }
   var linkfortabList= $(e.currentTarget).attr('urlVal');
    const withHttp = urls => !/^https?:\/\//i.test(urls) ? `http://${urls}` : urls;
    const qualifiedUrltabList =withHttp(linkfortabList);
    getMetaDataOfTabcalender(qualifiedUrltabList);
    window.open(qualifiedUrltabList, '_blank');
});

  //  --------------------------------------------------------------------------------- 
  //  Modal Carousel in Modal
  window.galleryModal = () => {
    window.swiper1 = new Swiper('#property-content-modal .carousel-1', {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 15,
      slideToClickedSlide: true,
      allowTouchMove: true,
      breakpoints: {
        0: {
          slidesPerView: 3
        },
        500: {
          slidesPerView: 4
        }
      },
      navigation: {
        nextEl: '#property-content-modal .swiper-button-next',
        prevEl: '#property-content-modal .swiper-button-prev',
        disabledClass: 'disabled'
      },
      on: {
        snapGridLengthChange:function(){
          if( this.snapGrid.length != this.slidesGrid.length ){
            this.snapGrid = this.slidesGrid.slice(0);
          }
        }
      }
    });

    window.swiper2 = new Swiper('#property-content-modal .carousel-2', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      allowTouchMove: false
    });

    swiper1.controller.control = swiper2;
  };
  //  --------------------------------------------------------------------------------- 

  //  --------------------------------------------------------------------------------- 
  //  SpecialDay Modal Carousel
  window.sepcialDayModalGallery = () => {
    var swiper1 = new Swiper('#specialDay_modal .specialday-modal__preview__posts', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".specialday-modal__preview__posts .swiper-pagination",
        clickable: true
      },
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.specialday-modal__preview__posts .swiper-button-next',
        prevEl: '.specialday-modal__preview__posts .swiper-button-prev',
        disabledClass: 'disabled'
      },
      on: {
        slideChange:function(swiper){
          $('.specialday-modal__preview__captions input[type=checkbox]').prop('checked', false);
          $('.specialday-modal__thumbnails .item').removeClass('active');
          $(`.specialday-modal__thumbnails .row [class*=col]:nth-of-type(${swiper.activeIndex + 1}) .item`).addClass('active');
        }
      }
    });

    $(document).on('click', '.specialday-modal__thumbnails .item', function(){
      // add active class to clicked item
      $('.specialday-modal__thumbnails .item').removeClass('active');
      $(this).addClass('active');
      
      var index = $(this).parents('[class*=col]').index();
      swiper1.slideTo(index);
    })

    var swiper2 = new Swiper('#specialDay_modal .specialday-modal__preview__captions', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 30,
      allowTouchMove: false
    });

    swiper1.controller.control = swiper2;
  };
  //  --------------------------------------------------------------------------------- 

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  //console.log('------------ Mobile Device ------------------------');
  setTimeout(function () {
    $('.history a[href="#tab-list"]').trigger('click');
  },400);

    document.addEventListener("DOMContentLoaded", function(event) {
    /* 
      - Code to execute when only the HTML document is loaded.
      - This doesn't wait for stylesheets, 
        images, and subframes to finish loading. 
    */

        $('.agency_contents.index').attr('style','max-height:'+getdynamicHeight(200)+'; min-height:'+getdynamicHeight(200)+'; height:'+getdynamicHeight(200) );
        $('.dashboard.contents').attr('style','max-height:'+getdynamicHeight(232)+'; min-height:'+getdynamicHeight(232)+'; height:'+getdynamicHeight(232) );
      
        //  Dashboard
        $('.dashboard.index').attr('style','max-height:'+getdynamicHeight(0)+'; min-height:'+getdynamicHeight(0)+'; height:'+getdynamicHeight(0) );
    });

    function getdynamicHeight(subValue){
      let initHeight = window.innerHeight;
      let calculatedHeight = initHeight- subValue;
      return calculatedHeight+'px !important';
    }
 }

 $(document).ready(function() {
  $( function() {
    $( "#datepickernew" ).datepicker({
      dateFormat: 'dd/mm/yy',
      beforeShow: function( input, inst){
        $(inst.dpDiv).addClass('moment-new-cal');
      },
    });
  });
  if (window.File && window.FileList && window.FileReader) {
    $(".files").on("change", function(e) {
      var fileName = $(this).val().split("\\").pop();
      $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
      var fileInput= $(this);
      var parentDiv= $(this).parents('div.field').find('.pip')
      var files = e.target.files,
        filesLength = files.length;
      for (var i = 0; i < filesLength; i++) {
        var f = files[i]
        var fileReader = new FileReader();
        fileReader.onload = (function(e) {
          $(parentDiv).find("span.icon").addClass('d-none');
          $(parentDiv).find(".img-holder").remove();
          $(parentDiv).append("<span class='img-holder' style='background-image:url("+ e.target.result +");'>" +
            "<span class=\"remove\">Remove image</span></span>");
          $(".remove").click(function(){
            $(this).parent(".img-holder").remove();
            $(fileInput).parents('div.field').find("span.icon").removeClass('d-none');
            $(fileInput).siblings(".custom-file-label").html('Choose file');
            fileInput='';
            parentDiv='';
          });
        });
        fileReader.readAsDataURL(f);
      }
      console.log(files);
    });
  } else {
    alert("Your browser doesn't support to File API")
  }
});;

window.setupDateTimePicker = () => {
    $("#datepickernew, .datepickernew" ).datepicker({
        dateFormat: 'dd/mm/yy',
        beforeShow: function( input, inst){
            $(inst.dpDiv).addClass('moment-new-cal');
        },
    });
};

const getHostname = (url) => {
  // use URL constructor and return hostname
  return new URL(url).hostname;
}

$(document).on('show.bs.modal', '#galleryModal', function () {

  //$('.owl-item.active .edit-name').on('click', function (e) {
    $(document).on('click', '.owl-item.active .edit-name', function(e) {
      e.preventDefault();
      $(this).addClass('d-none');
      $('.owl-item.active .update-name').removeClass('d-none');
      $('.owl-item.active .name-action input').attr('readonly', false);
    });

  //$('.owl-item.active .update-name').unbind("click").on('click', function (e) {
    $(document).on('click', '.owl-item.active .update-name', function(e) {
      e.preventDefault();
      $(this).addClass('d-none');
      $('.owl-item.active .edit-name').removeClass('d-none');
      $('.owl-item.active .name-action input').attr('readonly', true);
    });

  // function updateNamefn(e){
  //   e.preventDefault();
  //   $(this).closest('form')[0].requestSubmit();
  // }
});

// watch the content pipeline theme selectbox to redirect to the correct pipeline
$(document).on('change', 'select.content-pipeline-theme-id', (e) => {
  window.spin(true)
  e.preventDefault()

  const select = $(e.target)
  const option = select.find('option:selected')
  const type = option.attr('data-type')
  const themeId = option.val()

  window.location.href = `/users/content_pipeline?theme_id=${themeId}&type=${type}`
})

// watch the auto publish pipeline theme selectbox to redirect to the correct pipeline
$(document).on('change', 'select.auto-publish-pipeline-theme-id', (e) => {
  window.spin(true)
  e.preventDefault()

  const select = $(e.target)
  const option = select.find('option:selected')
  const type = option.attr('data-type')
  const themeId = option.val()

  window.location.href = `/users/auto_publish_pipelines?theme_id=${themeId}&type=${type}`
})